
define('text!modules/campaign/bulkedit/targeting/location/templates/panel.html',[],function () { return '<div class="w-box w-LocationTargeting w-BulkeditLocationTargeting">\n\t<div class="w-body w-panel-body"><!-- The Search & browse views render here--></div>\n\t<div class="w-foot">{{>footer}}</div>\n</div>\n';});

